import React from 'react';
import { Logo } from '../../Logo/Logo';
import { SideBarButton } from '../../SideBarButton/SideBarButton';
import { ISideNavigationMenuItemsConfig } from '../SideNavigationMenuConfiguration';
import { SideNavigationMenuItems } from '../SideNavigationMenuItems/SideNavigationMenuItems';
import { useSideBarTemplateStyles } from './SideBarTemplate.styles';

export type SideBarTemplateProps = {
    isCollapsible: boolean;
    handleOpenNewCertifiedFileModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    handleOpenNewRequestModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    handleOpenSendboardLeaveModal: (route: string) => void;
    logoUrl: string;
    showCertificateButton: string | boolean;
    showNewRequest: boolean;
    currentHash: string;
    menuConfig: ISideNavigationMenuItemsConfig[];
};

export const SideBarTemplate = ({
    isCollapsible,
    handleOpenNewCertifiedFileModal,
    handleOpenNewRequestModal,
    handleOpenSendboardLeaveModal,
    logoUrl,
    showCertificateButton,
    showNewRequest,
    currentHash,
    menuConfig,
}: SideBarTemplateProps) => {
    const classes = useSideBarTemplateStyles({ showCertificateButton });
    return (
        <>
            <div className={classes.logo}>
                <Logo
                    isCollapsible={isCollapsible}
                    handleOpenSendboardLeaveModal={handleOpenSendboardLeaveModal}
                    logoUrl={logoUrl}
                />
            </div>
            <div className={classes.content}>
                {(showCertificateButton || showNewRequest) && (
                    <div className={classes.button}>
                        <SideBarButton
                            handleOpenNewCertifiedFileModal={handleOpenNewCertifiedFileModal}
                            handleOpenNewRequestModal={handleOpenNewRequestModal}
                            showCertificateButton={showCertificateButton}
                        />
                    </div>
                )}
                <div className={classes.items}>
                    <SideNavigationMenuItems
                        items={menuConfig}
                        hash={currentHash}
                        isSendboard={isCollapsible}
                        handleOpenSendboardLeaveModal={handleOpenSendboardLeaveModal}
                    />
                </div>
            </div>
        </>
    );
};
